import * as Actions from '../Actions/ConteudoActions';
// import _ from '@lodash';

const initialState = {
    data: null,
    error: null,
    warning: null,
    info: null,
    dialog: null
};

const ConteudoReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_CONTEUDOS:
            {
                return {
                    ...state,
                    data: action.payload
                };
            }
        case Actions.CONTEUDO_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.CONTEUDO_INFO:
            {
                return {
                    ...state,
                    info: action.payload
                };
            }
        case Actions.CONTEUDO_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        case Actions.OPEN_CONTEUDO_DIALOG:
            {
                return {
                    ...state,
                    dialog: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

const reducer = ConteudoReducer;
export default reducer;
